/* lua.js generated code 0.3.1 */

let GameGuideMask = require("clover/gameGuide/GameGuideMask")
let GameGuideAnims = require("clover/gameGuide/GameGuideAnims")
var Tutorial = xClass("PassLevelWinChallengeGuide")
Tutorial.prototype.start = function (panel, text, callback, isFake = false, skipButtonOffsetY = 0) {
    let self = this
    self.isFake = isFake;
    let mask = self.mask(panel, callback)
    let animal = self.animal(panel, text)
    // if (animal) {
    //     mask.addChild(animal)
    // }
    
    var text = cc.Label.createWithSystemFont(getText("passlevel.showoff.quit.button"), null, 28)
    text.setColor(cc.c4b(240, 255, 255, 255))
    text.setAnchorPoint(cc.p(0, 0))
    var vSize = cc.Director.getInstance().getVisibleSize()
    var size = text.getContentSize()
    text.setPosition(cc.p(vSize.width - size.width / 2 - 100, size.height / 2 + 20 + _safe_area_bottom + skipButtonOffsetY))
    self.skipTxt = text
    panel.getParent().addChild(text, 1001)

    self.skipButton = UIButton.create(text);
    self.skipButton.on(UIButtonEvent.Click, function(){
        mask.removeFromParent(true)
            self.skipTxt && self.skipTxt.removeFromParent(true);
            self.bubble && self.bubble.removeFromParent(true);
            if (callback) {
                // callback()
            }
    })

    let handle = self.handleAnim(panel)
    if(handle) {
        mask.addChild(handle)
    }
    panel.getParent().addChild(mask, 1000)

    var uid = UserManager.getInstance().uid;
    var http = PassLevelShowOffSuccHttp.new();
    http.load(uid, true);

    self.mask = mask;
    return self;
}
Tutorial.prototype.handleAnim = function(panel) {
    let self = this
    let position = cc.p(100, 100)
    let button = panel.showoff //showoff是三星通关结束界面的分享挑战按钮
    if (button && button instanceof cc.Node) {
        position = button.convertToWorldSpace(cc.p(0, 0))
    }

    let action = table(
        [1, "type", "clickHand"],
        [1, "delay", 0.2],
        [1, "posMode", "win"],
        [1, "p1", position.x+70],
        [1, "p2", position.y]
    )
    let animal = GameGuideAnims.handClick(action)

    // animal.x = position.x
    // animal.y = position.y
    return animal
}
Tutorial.prototype.mask = function (panel, callback) {
    let self = this
    let position
    if (panel.button) {
        position = panel.button.convertToWorldSpace(cc.p(0, 0))
    }else {
        position = cc.p(100, 100)
    }
    let action = table(
        [1, "type", "mask"],
        [1, "fade", 0.01],
        [1, "touchDelay", 1.5],
        [1, "opacity", null]
    )
    // action.hole = table([0, table(
    //         [1, "type", "square"],
    //         [1, "border", 2],
    //         [1, "posMode", "win"],
    //         [1, "p1", position.x + 142],
    //         [1, "p2", position.y - 60],
    //         [1, "width", 270],
    //         [1, "height", 123]
    //     )])
    // action.touch = table([0, table(
    //         [1, "type", "square"],
    //         [1, "border", 2],
    //         [1, "posMode", "win"],
    //         [1, "p1", position.x + 142],
    //         [1, "p2", position.y - 60],
    //         [1, "width", 270],
    //         [1, "height", 123]
    //     )])
    action.hole = table([0, table(
            [1, "type", "oval"],
            [1, "border", 2],
            [1, "posMode", "win"],
            [1, "p1", position.x + 170],
            [1, "p2", position.y - 43],
            [1, "width", 190],
            [1, "height", 100]
        )])
    if (self.isFake){
        action.touch = table([0, table(
                [1, "type", "oval"],
                [1, "border", 2],
                [1, "posMode", "win"],
                [1, "p1", position.x + 185],
                [1, "p2", position.y - 23],
                [1, "width", 300 / 2],
                [1, "height", 140 / 3]
            )])
    }else{
        action.touch = table([0, table(
                [1, "type", "oval"],
                [1, "border", 2],
                [1, "posMode", "win"],
                [1, "p1", position.x + 235],
                [1, "p2", position.y - 43],
                [1, "width", 300 / 2],
                [1, "height", 140 / 3]
            )])
    }
    action.touchSkip = true

    let mask = UIButton.create(GameGuideMask.create(action))
    if (!self.isFake){
        mask.runAction(cc.Sequence.create(cc.DelayTime.create(1), cc.CallFunc.create(function () {
            mask.on(UIButtonEvent.Click, function () {
                mask.removeFromParent(true)
                self.skipTxt && self.skipTxt.removeFromParent(true)
                if (callback) {
                    // callback()
                }
            })
        }), cc.DelayTime.create(4), cc.CallFunc.create(function(){
            mask.removeFromParent(true)
            self.skipTxt && self.skipTxt.removeFromParent(true)
            // if (callback) {
            //     callback()
            // }
        })))
    }
    let size = mask.getContentSize()
    mask.setContentSize(cc.size(size.width + 240, size.height))

    return mask
}
Tutorial.prototype.animal = function (panel, text, mask) {
    let self = this
    let position
    // let size = cc.size(440, 145)
    let size = cc.size(400, 145)
    let button = panel.button
    if (button && button instanceof cc.Node) {
        let pos = button.convertToWorldSpace(cc.p(0, 0))
        position = pos.y + 70
    }else {
        position = 100
    }
    // // text = "技巧出神入化，位于全国第****名。点击“发起挑战”接受更多好友的挑战吧！"
    // let action = table(
    //     [1, "type", "bubble"],
    //     [1, "scale", 0.85],
    //     [1, "skipText", false],
    //     [1, "posMode", "win"],
    //     [1, "flip", false],
    //     [1, "p1", 460],
    //     [1, "p2", position || 200],
    //     [1, "bubblePos", 1],
    //     [1, "delay", 0.5],
    //     [1, "fontSize", 28],
    //     [1, "fontColor", cc.c4b(172, 110, 64, 255)],
    //     [1, "bubbleSize", size || cc.size(450, 205)],
    //     [1, "text", text],
    //     // [1, "textMargin", cc.p(30, 20)]
    //     // [1, "textMargin", cc.p(41, 17)]
    //     [1, "textMargin", cc.p(20, 17)]
    // )
    // let animal = GameGuideAnims.singleBubble(action)
    
    // return animal
    function success() {
        var bubble = cc.CSLoader.createNode("cocos/panel_success_challenge_bubblebox.csb");
        panel.getParent().addChild(bubble, 1002);
        var p = panel.convertToWorldSpace(cc.p(70, -130));
        bubble.setPosition(p);
        bubble.getChildByName("txt").setVisible(false);
        bubble.getChildByName("num").setVisible(false);

        var txt = GameGuideAnims.createMixedText(text, 25, cc.c4b(37,58,119,255), 320, "left");
        txt.setAnchorPoint(cc.p(0.5, 0.5));
        txt.setPosition(cc.p(20, 155));
        bubble.getChildByName("pnl_bubble").addChild(txt)

        self.bubble = bubble;
    }
    preloadWithLoading(["packed/WinChallengeRes.pack"], success, function () {
        Toast.make(getText("error.tip.load_res_error"));
    }, function () {
        Toast.make(getText("error.tip.load_canceled"));
    })
}
module.exports = Tutorial
